import { asyncAction, action } from 'lib/actions';

export const fetchMediumsAction = asyncAction('mediums/FETCH');
export const setCommonMediumsAction = action('mediums/SET_COMMON');
